import React, { useState } from 'react';
import { connect } from 'react-redux';
import { addToCart } from '../actions/actions';
import './foodDetails.scss';

const FoodDetails = ({ food, addToCart, onClose }) => {
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [selectedSpecial, setSelectedSpecial] = useState([]);
  const [selectedExtra, setSelectedExtra] = useState([]);
  const [activeTab, setActiveTab] = useState('addons');
  const [note, setNote] = useState('');

  const toggleSelection = (id, category) => {
    if (category === 'addons') {
      setSelectedAddons((prev) =>
        prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
      );
    } else if (category === 'special') {
      setSelectedSpecial((prev) =>
        prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
      );
    } else if (category === 'extra') {
      setSelectedExtra((prev) =>
        prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
      );
    }
  };

  const calculateExtraTotal = () => {
    const sum = (items, selected) => {
      return (
        items
          ?.filter((item) => selected.includes(item._id))
          .reduce((acc, item) => acc + (item.addOnPrice || 0), 0) || 0
      );
    };

    return (
      sum(food.addons, selectedAddons) +
      sum(food.specialRequest, selectedSpecial) +
      sum(food.extraRequest, selectedExtra)
    );
  };

  const finalPrice = (food.price || 0) + calculateExtraTotal();

  const handleAddToCart = () => {
    const cartItem = {
      ...food,
      note: note.trim(),
      addons:
        food.addons?.filter((item) => selectedAddons.includes(item._id)) || [],
      specialRequest:
        food.specialRequest?.filter((item) =>
          selectedSpecial.includes(item._id)
        ) || [],
      extraRequest:
        food.extraRequest?.filter((item) => selectedExtra.includes(item._id)) ||
        [],
      finalPrice,
    };

    addToCart(cartItem);
    onClose();
  };

  const tabs = [
    { id: 'addons', label: 'Addons', count: food.addons?.length || 0 },
    { id: 'special', label: 'Special', count: food.specialRequest?.length || 0 },
    { id: 'extra', label: 'Extra', count: food.extraRequest?.length || 0 },
  ].filter((tab) => tab.count > 0);

  const hasAnyRequests = tabs.length > 0;

  return (
    <div className="food-details-overlay">
      <div className="food-details-container">
        <div className="food-details-header">
          <h2>{food.title}</h2>
          {/* <button className="close-btn" onClick={onClose}>
            ×
          </button> */}
        </div>

        <div className="food-details-content">
          <div className="food-info-section">
            {food.img ? (
              <img src={food.img} alt={food.title} className="food-image" />
            ) : (
              <div className="food-image placeholder">No Image</div>
            )}

            <div className="food-meta">
              <p className="food-desc">{food.desc || 'No description available.'}</p>
              <p className="price">Base Price: RM {Number(food.price || 0).toFixed(2)}</p>
              <p className="total-price">Total: RM {Number(finalPrice).toFixed(2)}</p>
            </div>
          </div>

          {hasAnyRequests ? (
            <>
              <div className="tab-navigation">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    type="button"
                    className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                    onClick={() => setActiveTab(tab.id)}
                  >
                    {tab.label} ({tab.count})
                  </button>
                ))}
              </div>

              <div className="tab-content">
                {activeTab === 'addons' && food.addons?.length > 0 && (
                  <div className="optionSection">
                    {food.addons.map((item, index) => (
                      <div key={item._id || index} className="optionItem">
                        <input
                          id={`addon-${item._id}`}
                          type="checkbox"
                          checked={selectedAddons.includes(item._id)}
                          onChange={() => toggleSelection(item._id, 'addons')}
                        />
                        <label htmlFor={`addon-${item._id}`}>
                          <span>{item.name}</span>
                          <span>+RM {Number(item.addOnPrice || 0).toFixed(2)}</span>
                        </label>
                      </div>
                    ))}
                  </div>
                )}

                {activeTab === 'special' && food.specialRequest?.length > 0 && (
                  <div className="optionSection">
                    {food.specialRequest.map((item, index) => (
                      <div key={item._id || index} className="optionItem">
                        <input
                          id={`special-${item._id}`}
                          type="checkbox"
                          checked={selectedSpecial.includes(item._id)}
                          onChange={() => toggleSelection(item._id, 'special')}
                        />
                        <label htmlFor={`special-${item._id}`}>
                          <span>{item.name}</span>
                          <span>+RM {Number(item.addOnPrice || 0).toFixed(2)}</span>
                        </label>
                      </div>
                    ))}
                  </div>
                )}

                {activeTab === 'extra' && food.extraRequest?.length > 0 && (
                  <div className="optionSection">
                    {food.extraRequest.map((item, index) => (
                      <div key={item._id || index} className="optionItem">
                        <input
                          id={`extra-${item._id}`}
                          type="checkbox"
                          checked={selectedExtra.includes(item._id)}
                          onChange={() => toggleSelection(item._id, 'extra')}
                        />
                        <label htmlFor={`extra-${item._id}`}>
                          <span>{item.name}</span>
                          <span>+RM {Number(item.addOnPrice || 0).toFixed(2)}</span>
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          ) : (
            <p className="no-requests">No additional options available.</p>
          )}

<div className="food-note-section">
  <label>Note for kitchen</label>
  <textarea
    placeholder="e.g. No onion, less spicy..."
    value={note}
    onChange={(e) => setNote(e.target.value)}
    maxLength={200}
  />
  <div className="note-counter">{note.length}/200</div>
</div>

          <div className="button-container">
            <button type="button" className="add-btn" onClick={handleAddToCart}>
              Add to Cart
            </button>
            <button type="button" className="close-action-btn" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { addToCart })(FoodDetails);